import {
  INTAKE_QUESTION_CODES,
  INTAKE_QUESTION_TYPES,
} from "~/common/utils/consultations/intake";
import { AgreeDisagree } from "~/common/utils/consultations/intake/intakeTypes";

export const agreeDisagreeQuestions = {
  [INTAKE_QUESTION_CODES.i_have_no_major_health_worries]: {
    title: "I have no major health worries.",
    type: INTAKE_QUESTION_TYPES.radio,
    options: AgreeDisagree,
  },
  [INTAKE_QUESTION_CODES.i_dont_worry_about_finances]: {
    title: "I don’t worry about finances.",
    type: INTAKE_QUESTION_TYPES.radio,
    options: AgreeDisagree,
  },
} as const;
